import * as Color from 'color';

export function getRandomArbitrary(min = 0, max = 255) {
  return Math.floor(Math.random() * (max - min) + min);
}

const getRandomColor = (color: string | null) => {
  if (color) {
    return Color.rgb(color);
  }

  return Color.rgb(getRandomArbitrary(), getRandomArbitrary(), getRandomArbitrary());
};

const generateMainColor = (insertedcColor: string | null) => {
  const color = getRandomColor(insertedcColor);
  const [hue] = color?.hsv().array();
  if (insertedcColor) return color.hsv();
  return color.hsv(hue, getRandomArbitrary(50, 100), getRandomArbitrary(50, 100));
};

export default generateMainColor;
